<template>
    <svg 
    :width="width"
    :height="height"
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.875 2H4.75C4.28587 2 3.84075 2.16857 3.51256 2.46863C3.18437 2.76869 3 3.17565 3 3.6V16.4C3 16.8243 3.18437 17.2313 3.51256 17.5314C3.84075 17.8314 4.28587 18 4.75 18H15.25C15.7141 18 16.1592 17.8314 16.4874 17.5314C16.8156 17.2313 17 16.8243 17 16.4V7.6V4C17 2.89543 16.1046 2 15 2H10.875Z" :stroke="iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.96289 6H14.0471" :stroke="iconColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M8.96289 10H14.0471" :stroke="iconColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M8.96289 14H14.0471" :stroke="iconColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="6" cy="6" r="1" :fill="iconColor"/>
        <circle cx="6" cy="10" r="1" :fill="iconColor"/>
        <circle cx="6" cy="14" r="1" :fill="iconColor"/>
    </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>